<template>
  <div class="dibu">
    <div class="bottom-tab">
      <a class="as" href="https://beian.miit.gov.cn/" target="_blank"
        >版权所有：金建建筑职业培训中心</a
      >
      <a class="as" href="https://beian.miit.gov.cn/" target="_blank"
        >主 办：金建建筑职业培训中心</a
      >
      <a class="as" href="https://beian.miit.gov.cn/" target="_blank"
        >备 案 号：津ICP备18006501号-2</a
      >
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.bottom-tab {
  width: 100%;
  height: 170px;
  background: #5b5e63;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 16px;
  color: #ffffff;
  /* margin-top: 101px; */
}
.as {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  padding: 5px 0;
  box-sizing: border-box;
}
</style>